(() => {
  let config = {};
  try { config = JSON.parse(document.getElementById('HHCampaignLimits')?.textContent || '{}'); } catch (error) {}
  const products = new Map((config.products || []).map(product => [String(product.id), product]));
  const variants = new Map((config.products || []).flatMap(product => (product.variants || []).map(id => [String(id), String(product.id)])));
  const productId = item => products.has(String(item.product_id)) ? String(item.product_id) : variants.get(String(item.variant_id || item.id));
  const count = (cart, id) => (cart.items || []).filter(item => productId(item) === String(id)).reduce((total, item) => total + Number(item.quantity || 0), 0);
  const updates = cart => {
    const retained = new Set(), result = {};
    for (const item of cart.items || []) {
      const id = productId(item); if (!id) continue;
      const allowed = retained.has(id) ? 0 : Math.min(1, Number(item.quantity || 0));
      if (allowed) retained.add(id);
      if (Number(item.quantity) !== allowed) result[item.key] = allowed;
    }
    return result;
  };
  const messages = config.messages || {};
  const copy = config.continueMessages || {};
  const occupiedVariants = cart => {
    const result = new Set();
    const visit = item => {
      result.add(String(item.variant_id || item.id));
      for (const id of products.get(productId(item))?.includedVariants || []) result.add(String(id));
      for (const component of item.item_components || []) visit(component);
    };
    (cart.items || []).forEach(visit);
    return result;
  };
  const incentive = (cart, state) => {
    if ((cart.currency || config.currency) !== 'AUD') return null;
    if (Number.isFinite(cart.total_price) && cart.total_price < 10000)
      return {type: 'shipping', remaining: 10000 - cart.total_price};
    if (!config.giftEnabled || !state) return null;
    if (state.eligible(cart)) return {type: state.giftLines(cart).length ? 'gift_selected' : 'gift_ready', remaining: 0};
    return {type: 'gift_remaining', remaining: Math.max(0, 12000 - state.paidSubtotal(cart))};
  };
  const formProduct = form => {
    const input = form.elements?.namedItem('id');
    return variants.get(String(input?.value || ''));
  };
  const api = {
    products, variants, productId, count, updates, messages, formProduct, occupiedVariants, incentive,
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style: 'currency', currency: 'AUD'}).format(cents / 100);
    },
    paintContinuation(cart) {
      const occupied = occupiedVariants(cart);
      const state = window.hhPantryGift?.state;
      const offer = incentive(cart, state);
      for (const panel of document.querySelectorAll('[data-hh-continue]')) {
        panel.hidden = products.has(panel.dataset.hhContinue) ? count(cart, panel.dataset.hhContinue) < 1 : !(cart.items || []).some(item => String(item.product_id) === panel.dataset.hhContinue);
        if (panel.hidden) continue;
        let visible = 0;
        for (const card of panel.querySelectorAll('[data-hh-pair-variant]')) {
          card.hidden = occupied.has(card.dataset.hhPairVariant) || window.hhPantryPairings?.occupiedProducts(cart).has(card.dataset.hhPairProduct) || (cart.items || []).some(item => String(item.product_id) === card.dataset.hhPairProduct);
          if (!card.hidden) visible++;
        }
        panel.querySelector('[data-hh-continue-pairings]').hidden = !visible || panel.dataset.hhPairingsLoading === 'true';
        const benefit = panel.querySelector('[data-hh-continue-benefit]');
        benefit.hidden = !offer;
        if (!offer) continue;
        const amount = this.money(offer.remaining);
        benefit.querySelector('p').textContent = (copy[offer.type] || '').replace('__AMOUNT__', amount);
        const link = benefit.querySelector('a');
        if (offer.type === 'shipping') {
          link.textContent = copy.shipping_terms;
          link.href = config.shippingUrl || window.hhPantryGift.root + 'cart';
        } else {
          link.textContent = offer.type === 'gift_ready' ? copy.gift_link : copy.gift_terms;
          link.href = window.hhPantryGift.root + 'cart#hh-organic-gift';
        }
      }
    },
    continueShopping(form, id, cart, coordinator) {
      const parent = form.closest?.('[data-hh-continue]');
      if (parent) {
        parent.querySelector('.hh-continue__top p').textContent = (copy.item_added || messages.added).replace('__PRODUCT__', form.dataset.hhPairName || '');
        this.paintContinuation(cart);
        return;
      }
      if (form.closest?.('cart-drawer,cart-items,.card-wrapper,.product-card-wrapper') && !form.closest?.('quick-add-modal')) { this.announce(messages.added); return; }
      if (!form.isConnected || typeof form.insertAdjacentElement !== 'function') { this.announce(messages.added); return; }
      let panel = form.nextElementSibling;
      if (!panel?.hasAttribute('data-hh-continue')) {
        panel = document.createElement('section');
        panel.className = 'hh-continue'; panel.setAttribute('data-hh-continue', id);
        panel.innerHTML = '<div class="hh-continue__top"><p role="status" aria-live="polite"></p><a></a></div><div data-hh-continue-benefit class="hh-continue__benefit" hidden><p></p><a></a></div><div data-hh-continue-pairings hidden><h3></h3><div class="hh-continue__products"></div></div>';
        panel.querySelector('.hh-continue__top p').textContent = copy.heading || messages.added;
        const cartLink = panel.querySelector('.hh-continue__top a');
        cartLink.textContent = copy.view_cart || messages.view_cart;
        cartLink.href = coordinator.root + 'cart';
        panel.querySelector('h3').textContent = copy.pairings;
        const template = document.getElementById('HHCampaignPairings-' + id);
        if (template) panel.querySelector('.hh-continue__products').append(template.content.cloneNode(true));
        form.insertAdjacentElement('afterend', panel);
      }
      this.paintContinuation(cart);
      window.hhPantryPairings?.populate(panel, String(id), cart, coordinator);
    },
    announce(message) {
      const notice = document.getElementById('HHCampaignStatus');
      if (!notice) return;
      notice.querySelector('[data-hh-campaign-status-text]').textContent = message;
      notice.hidden = false; clearTimeout(this.noticeTimer);
      this.noticeTimer = setTimeout(() => { notice.hidden = true; }, 9000);
    },
    async normalize(cart, coordinator) {
      const changes = updates(cart);
      if (!Object.keys(changes).length) return {cart, changed: false};
      cart = await coordinator.update({updates: changes});
      if (Object.keys(updates(cart)).length) throw new Error('Campaign quantities not confirmed');
      this.announce(messages.normalized);
      return {cart, changed: true};
    },
    paint(cart, busy = false) {
      this.paintContinuation(cart);
      document.documentElement.dataset.hhCampaignInCart = String((cart.items || []).some(item => productId(item)));
      for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
        const id = formProduct(form); if (!id) continue;
        const quantity = form.elements.namedItem('quantity');
        if (quantity) { quantity.value = '1'; quantity.min = '1'; quantity.max = '1'; quantity.readOnly = true; }
        const quantityBox = quantity?.closest('quantity-input');
        if (quantityBox) quantityBox.querySelectorAll('button').forEach(button => { button.disabled = true; });
        for (const button of form.querySelectorAll('[type="submit"],[data-hh-cart-quick-add]')) {
          const label = button.querySelector('[data-hh-limit-button-text],.hh-cart__upsell-add-label,span:not(.loading__spinner):not(.svg-wrapper)');
          if (label && !button.dataset.hhLimitLabel) button.dataset.hhLimitLabel = label.textContent;
          if (count(cart, id) >= 1) {
            if (!button.dataset.hhLimitDisabled) { button.dataset.hhLimitDisabled = 'true'; button.dataset.hhLimitWasDisabled = button.dataset.hhLimitPendingOriginal || String(button.disabled); }
            button.disabled = true;
            if (label) label.textContent = messages.in_cart;
          } else if (button.dataset.hhLimitDisabled) {
            button.disabled = button.dataset.hhLimitWasDisabled === 'true';
            delete button.dataset.hhLimitDisabled; delete button.dataset.hhLimitWasDisabled;
            if (label && button.dataset.hhLimitLabel) label.textContent = button.dataset.hhLimitLabel;
          }
        }
      }
      for (const input of document.querySelectorAll('[data-hh-campaign-product]')) {
        if (!products.has(String(input.dataset.hhCampaignProduct))) continue;
        input.max = '1'; input.step = '1';
        const plus = input.closest('quantity-input')?.querySelector('button[name="plus"]');
        if (plus) plus.disabled = true;
      }
    },
    async add(form, button, coordinator) {
      const id = formProduct(form) || window.hhPantryPairings?.source(form); if (!id) return;
      const limited = products.has(String(id));
      const data = new FormData(form); if (limited) data.set('quantity', '1');
      const wasDisabled = button?.disabled;
      if (button) { button.dataset.hhLimitPendingOriginal = String(!!wasDisabled); button.disabled = true; button.setAttribute('aria-busy', 'true'); button.classList.add('loading'); }
      try {
        await coordinator.run(async () => {
          let cart = await coordinator.reconcile();
          if (limited && count(cart, id) >= 1) { this.announce(messages.already_in_cart); return; }
          if (form.matches?.('[data-hh-pair-add-form]') && occupiedVariants(cart).has(String(data.get('id')))) { this.paintContinuation(cart); return; }
          const drawer = document.querySelector('cart-drawer');
          const sections = coordinator.sectionIds().filter(section => section !== 'cart-drawer' || drawer);
          data.set('sections', [...new Set(sections)].slice(0, 5).join(','));
          data.set('sections_url', location.pathname);
          const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000);
          let response;
          try {
            const raw = await fetch(coordinator.root + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body: data, signal: controller.signal});
            response = await raw.json();
            if (!raw.ok || response.status >= 400) throw new Error('Campaign unavailable');
          } finally { clearTimeout(timer); }
          cart = await coordinator.reconcile();
          const freshSections = cart.sections;
          cart.sections = {...response.sections, ...freshSections};
          await coordinator.refresh(cart);
          this.continueShopping(form, id, cart, coordinator);
        });
      } catch (error) { this.announce(messages.error); }
      finally {
        if (button?.isConnected) {
          button.classList.remove('loading'); button.removeAttribute('aria-busy'); delete button.dataset.hhLimitPendingOriginal;
          if (!button.dataset.hhLimitDisabled) button.disabled = !!wasDisabled;
        }
        if (coordinator.cart) this.paint(coordinator.cart, false);
      }
    },
    install(coordinator) {
      if (!products.size || this.installed) return;
      this.installed = true;
      document.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('form[action*="/cart/add"]') || !(formProduct(form) || window.hhPantryPairings?.source(form))) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.add(form, event.submitter || form.querySelector('[type="submit"]'), coordinator);
      }, true);
      document.addEventListener('click', event => {
        if (event.target.closest('[data-hh-campaign-dismiss]')) { document.getElementById('HHCampaignStatus').hidden = true; return; }
        const button = event.target.closest('[data-hh-cart-quick-add]'), form = button?.closest('form');
        if (!form || !(formProduct(form) || window.hhPantryPairings?.source(form))) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (!button.disabled) this.add(form, button, coordinator);
      }, true);
      const start = () => {
        coordinator.start();
        if (typeof MutationObserver !== 'undefined' && document.body) {
          this.observer = new MutationObserver(records => {
            if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('form,product-form,quantity-input') || node.querySelector('form,product-form,quantity-input'))))) return;
            cancelAnimationFrame(this.paintFrame);
            this.paintFrame = requestAnimationFrame(() => { if (coordinator.cart) this.paint(coordinator.cart, coordinator.busy); });
          });
          this.observer.observe(document.body, {childList: true, subtree: true});
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
      window.addEventListener('pageshow', event => { if (event.persisted) coordinator.run(() => coordinator.reconcile()).catch(() => {}); });
    }
  };
  window.hhCampaignLimits = api;
})();


